'use client'

import { BookmarkIconSVG } from '@/components/svg/bookmark-icon/bookmark-icon'
import { FAVOURITE } from '@/constants'
import { useSignUpModal } from '@/hooks/use-sign-up-modal'
import { useUser } from '@/hooks/use-user'
import cx from 'classnames'
import s from './bookmark-icon.module.css'

interface IBookmarkIconProps {
  itemId: number | string
  type: FAVOURITE
  className?: string
  primaryColor?: string
  /**
   * Names the thing being saved, so an icon-only button reads as
   * "Save Gunnersbury Park" rather than the generic article wording. Supply it
   * wherever several bookmarks sit on one screen (e.g. a grid of credits).
   */
  itemLabel?: string
}

export const BookmarkIcon = ({
  itemId,
  type,
  className,
  primaryColor = '#131313',
  itemLabel,
}: IBookmarkIconProps) => {
  const user = useUser()
  const isFavourite = user.hasFavourite(Number(itemId), type)
  const signUpModal = useSignUpModal()

  const handleOnClickFavourite = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation()
    e.preventDefault()

    if (user.isReader) {
      user.toggleFavourite(Number(itemId), type)
    } else {
      signUpModal.open()
    }
  }

  if (user.isSupplier || user.isAdmin) {
    return null
  }

  return (
    <button
      className={cx(s.bookmarkButton, className)}
      onClick={handleOnClickFavourite}
      aria-label={
        itemLabel
          ? isFavourite
            ? `Remove ${itemLabel} from your shortlist`
            : `Save ${itemLabel} to your shortlist`
          : isFavourite
            ? 'Remove from bookmarks'
            : 'Save this article to bookmarks'
      }
    >
      <BookmarkIconSVG
        svgProps={{
          ...(isFavourite && { fill: primaryColor }),
          className: s.bookmarkIcon,
        }}
        strokeColor={primaryColor}
      />
    </button>
  )
}
